import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50baea05")

_pushScopeId("data-v-50baea05")
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-filter" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-plus" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SearchNavBar = _resolveComponent("SearchNavBar")
  const _component_MovementListItem = _resolveComponent("MovementListItem")
  const _component_InfiniteListWrapper = _resolveComponent("InfiniteListWrapper")
  const _component_ActionButton = _resolveComponent("ActionButton")
  const _component_ActionBar = _resolveComponent("ActionBar")
  const _component_MovementFilterDialog = _resolveComponent("MovementFilterDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_SearchNavBar, {
      search: _ctx.searchText,
      "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchText = $event)),
      title: "Movimentos",
      navigation: _ctx.navigation,
      "search-placeholder": "Pesquisar por peixe..."
    }, null, 8, ["search", "navigation"]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_InfiniteListWrapper, {
        records: _ctx.movements,
        loading: _ctx.loading,
        error: _ctx.error,
        "error-msg": "Não foi possível carregar seus movimentos.",
        "reload-cb": _ctx.loadMovements,
        "infinite-cb": _ctx.handleInfiniteScroll
      }, {
        default: _withId((slotProps) => [
          _createVNode(_component_MovementListItem, {
            movement: slotProps.record,
            onClick: ($event: any) => (_ctx.handleEdit(slotProps.record.id))
          }, null, 8, ["movement", "onClick"])
        ]),
        _: 1
      }, 8, ["records", "loading", "error", "reload-cb", "infinite-cb"])
    ]),
    _createVNode(_component_ActionBar, { class: "actions" }, {
      default: _withId(() => [
        _createVNode(_component_ActionButton, {
          type: "secondary",
          "data-test": "filter",
          onClick: _ctx.openFilterDialog
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_ActionButton, {
          "data-test": "actionCreate",
          onClick: _ctx.handleCreate
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_MovementFilterDialog, {
      visible: _ctx.filterDialogVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterDialogVisible = $event)),
      filters: _ctx.filters,
      modal: true,
      onApply: _ctx.handleApplyFilter
    }, null, 8, ["visible", "filters", "onApply"])
  ]))
})